import { Button } from '../../../../components/ui/button'
import { Modal } from '../../../../components/ui/modal'
import { DataComTraçoParaDataComBarra } from '../../../../utils/dates'
import { Select } from '../../../../components/ui/select'
import { Input } from '../../../../components/ui/input'
import { Column } from '../../../../components/layouts/columns'
import { Icon } from '../../../../components/icons'
import { Form } from '../../../../components/ui/form'
import { Table } from '../../../../components/ui/table'
import { statusStaff } from '../_utils/statusCandidate'

export const ModalSelectCandidacy = ({
  loading,
  active = true,
  setActive,
  dataContext,
  datafull,
  filter,
  setFilter,
  FormAction,
  infosContext,
  actions,
}) => {
  const type = datafull?.typeSelectCandidacy
  const list = type ? datafull?.[`list_${type}`] || [] : []

  const { date, round, positionName, status, search = '' } = filter

  const normalizedSearch = search.toLowerCase()
  const normalizedStatus = Number(status)

  const dataFiltered = dataContext.filter((data) => {
    const jobOffer = data.jobOffer || {}
    const position = jobOffer.position || {}

    if (date !== 'todos' && jobOffer.date !== date) return false
    if (round !== 'todos' && jobOffer.round !== round) return false
    if (positionName !== 'todos' && positionName !== (position.name || position.nome)) return false
    if (status !== 'todos' && Number(data.status) !== normalizedStatus) return false

    if (normalizedSearch) {
      const lowerName = (data.name || '').toLowerCase()
      const lowerNome = (data.nome || '').toLowerCase()
      const cpf = String(data.cpf || '').toLowerCase()

      if (
        !lowerName.includes(normalizedSearch) &&
        !lowerNome.includes(normalizedSearch) &&
        !cpf.includes(normalizedSearch)
      ) {
        return false
      }
    }

    return true
  })

  if (active) {
    return (
      <div>
        <Modal.Root active={active}>
          <Modal.Contents witdh={1200}>
            <Modal.Header title={'Selecionar Candidatura'}>
              <Modal.HeaderClose setActive={setActive}></Modal.HeaderClose>
            </Modal.Header>

            <Modal.Body>
              <Form.Root
                action={() => {
                  FormAction()
                }}
              >
                <Column.Root className="is-mobile">
                  <Column.Content>
                    <Input.Root>
                      <Input.Label className="ml-3 has-text-grey-light is-size-7" style={{ marginBottom: 0 }}>
                        Data
                      </Input.Label>
                      <Select.Root>
                        <Select.Content
                          color="is-grey"
                          className="is-fullwidth is-rounded is-small"
                          value={filter}
                          setValue={setFilter}
                          field={'date'}
                        >
                          <Select.Option value={'todos'} title={'Todos'} />
                          {infosContext?.filters?.dates.map((date) => {
                            return (
                              <Select.Option
                                key={`date-${date}`}
                                value={date}
                                title={DataComTraçoParaDataComBarra(date)}
                              />
                            )
                          })}
                        </Select.Content>
                      </Select.Root>
                    </Input.Root>
                  </Column.Content>
                  <Column.Content>
                    <Input.Root>
                      <Input.Label className="ml-3 has-text-grey-light is-size-7" style={{ marginBottom: 0 }}>
                        Turno
                      </Input.Label>
                      <Select.Root>
                        <Select.Content
                          color="is-grey"
                          className="is-fullwidth is-rounded is-small"
                          value={filter}
                          setValue={setFilter}
                          field={'round'}
                        >
                          <Select.Option value={'todos'} title={'Todos'} />
                          {[...new Set(Object.values(infosContext?.jobOffers || {}).map((job) => job.round))]
                            .sort((a, b) => a.localeCompare(b, 'pt-BR', { numeric: true }))
                            .map((round) => (
                              <Select.Option key={`round-${round}`} value={round} title={round}>
                                {round}
                              </Select.Option>
                            ))}
                        </Select.Content>
                      </Select.Root>
                    </Input.Root>
                  </Column.Content>
                  <Column.Content>
                    <Input.Root>
                      <Input.Label className="ml-3 has-text-grey-light is-size-7" style={{ marginBottom: 0 }}>
                        Vaga
                      </Input.Label>
                      <Select.Root>
                        <Select.Content
                          color="is-grey"
                          className="is-fullwidth is-rounded is-small"
                          value={filter}
                          setValue={setFilter}
                          field={'positionName'}
                        >
                          <Select.Option value={'todos'} title={'Todos'} />
                          {infosContext?.filters?.positions.map((position) => {
                            return (
                              <Select.Option
                                key={`position-${position}`}
                                value={infosContext?.positionsById[position]}
                                title={infosContext?.positionsById[position]}
                              />
                            )
                          })}
                        </Select.Content>
                      </Select.Root>
                    </Input.Root>
                  </Column.Content>
                  <Column.Content>
                    <Input.Root>
                      <Input.Label className="ml-3 has-text-grey-light is-size-7" style={{ marginBottom: 0 }}>
                        Status
                      </Input.Label>
                      <Select.Root>
                        <Select.Content
                          color="is-grey"
                          className="is-fullwidth is-rounded is-small"
                          value={filter}
                          setValue={setFilter}
                          field={'status'}
                        >
                          <Select.Option value={'todos'} title={'Todos'} />
                          {Object.keys(statusStaff).map((status) => {
                            // console.log()
                            return (
                              <Select.Option
                                key={`status-${status}`}
                                value={status}
                                title={`${status} - ${statusStaff[status].status}`}
                              />
                            )
                          })}
                        </Select.Content>
                      </Select.Root>
                    </Input.Root>
                  </Column.Content>
                  <Column.Content size="is-1">
                    <Button.Root align="is-center">
                      <Button.Content>
                        <Button.Bt
                          className="mt-4 is-rounded"
                          color="is-light"
                          size={'is-small'}
                          loading={loading}
                          title={'Enviar Convite'}
                          type="button"
                          action={() => {
                            setFilter((prev) => ({
                              ...prev,
                              date: 'todos',
                              round: 'todos',
                              status: 'todos',
                              positionName: 'todos',
                            }))
                          }}
                        >
                          Limpar
                        </Button.Bt>
                      </Button.Content>
                    </Button.Root>
                  </Column.Content>
                </Column.Root>
              </Form.Root>

              <>
                <Column.Root className="is-mobile">
                  <Column.Content>
                    <Input.Root>
                      <Input.Contents alignIcon={'left'}>
                        <Input.Prompt
                          value={filter}
                          setValue={setFilter}
                          field={'search'}
                          placeholder="Pesquisar..."
                        ></Input.Prompt>
                        <Input.Icon align="is-left">
                          <Icon size={20}>search</Icon>
                        </Input.Icon>
                      </Input.Contents>
                    </Input.Root>
                  </Column.Content>
                </Column.Root>

                <Table.Root className="is-fullwidth is-hoverable is-narrow has-text-centered">
                  <Table.Head>
                    <Table.Row key={'tableEventsHead'}>
                      <Table.Cell>Data</Table.Cell>
                      <Table.Cell>Turno</Table.Cell>
                      <Table.Cell>Vaga</Table.Cell>
                      <Table.Cell>Colaborador</Table.Cell>
                      <Table.Cell>CPF</Table.Cell>
                      <Table.Cell>Status</Table.Cell>
                      <Table.Cell>Ações</Table.Cell>
                    </Table.Row>
                  </Table.Head>
                  <Table.Body>
                    {dataFiltered.slice(0, 100).map((candidacy) => {
                      const hasSelected = list.find((d) => d.id === candidacy.id)

                      const positionName =
                        candidacy?.jobOffer?.position?.nome || candidacy?.jobOffer?.position?.name || null
                      const round = candidacy?.jobOffer?.round || null
                      const date = candidacy?.jobOffer?.date || null
                      return (
                        <Table.Row key={`candidacyRow${candidacy.id}`}>
                          <Table.Cell className="has-text-centered is-vcentered">
                            {DataComTraçoParaDataComBarra(date)}
                          </Table.Cell>
                          <Table.Cell className="has-text-centered is-vcentered">{round}</Table.Cell>
                          <Table.Cell className="has-text-centered is-vcentered">{positionName}</Table.Cell>
                          <Table.Cell className="has-text-centered is-vcentered">{candidacy.name}</Table.Cell>
                          <Table.Cell className="has-text-centered is-vcentered">{candidacy.cpf}</Table.Cell>
                          <Table.Cell className="has-text-centered is-vcentered">
                            <div className={`tag ${statusStaff[candidacy.status].color}`}>
                              {statusStaff[candidacy.status].status}
                            </div>
                          </Table.Cell>
                          <Table.Cell className="has-text-centered is-vcentered">
                            <Button.Bt
                              className="is-rounded"
                              color={!hasSelected ? 'is-grey' : 'is-success'}
                              size={'is-small'}
                              loading={loading}
                              title={'Selecionar'}
                              action={() => {
                                actions.select({ ...candidacy, date, positionName })
                              }}
                            >
                              {!hasSelected ? (
                                <Icon size={20} margin={-5}>
                                  arrowRight
                                </Icon>
                              ) : (
                                <Icon size={20} margin={-5}>
                                  check
                                </Icon>
                              )}
                            </Button.Bt>
                          </Table.Cell>
                        </Table.Row>
                      )
                    })}
                  </Table.Body>
                </Table.Root>
              </>
            </Modal.Body>
          </Modal.Contents>
        </Modal.Root>
      </div>
    )
  } else {
    return <></>
  }
}
